/**
 * App shell — 4 onglets (Vente / Crédit / Vitrine / Réglages) selon plan archi Mois 1.
 * 3 onglets dans le plan originel + Vitrine = branchement de la route vitrine du Core
 * (publication de la boutique + lecture publique pour /v/:id).
 */
import { useEffect, useState } from 'react';
import { Vente } from './pages/Vente';
import { CreditTab } from './pages/Credit';
import { Vitrine } from './pages/Vitrine';
import { Reglages } from './pages/Reglages';
import { enLigne } from './lib/api';

type Onglet = 'vente' | 'credit' | 'vitrine' | 'reglages';

export function App() {
  const [onglet, setOnglet] = useState<Onglet>('vente');
  const [reseau, setReseau] = useState(enLigne());

  useEffect(() => {
    const on = () => setReseau(true);
    const off = () => setReseau(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return (
    <>
      <div className={`indicateur-reseau ${reseau ? 'en-ligne' : ''}`}>
        ⚠️ Mode hors-ligne — les ventes s'enregistrent et syncroniseront plus tard
      </div>
      <main className="contenu" style={reseau ? {} : { paddingTop: 28 }}>
        {onglet === 'vente' && <Vente />}
        {onglet === 'credit' && <CreditTab />}
        {onglet === 'vitrine' && <Vitrine />}
        {onglet === 'reglages' && <Reglages />}
      </main>
      <nav className="tabbar" role="tablist">
        <button
          className={`tabbar-bouton ${onglet === 'vente' ? 'actif' : ''}`}
          onClick={() => setOnglet('vente')}
          aria-selected={onglet === 'vente'}
        >
          <span className="icone">🛒</span>
          <span>Vente</span>
        </button>
        <button
          className={`tabbar-bouton ${onglet === 'credit' ? 'actif' : ''}`}
          onClick={() => setOnglet('credit')}
          aria-selected={onglet === 'credit'}
        >
          <span className="icone">💳</span>
          <span>Crédit</span>
        </button>
        <button
          className={`tabbar-bouton ${onglet === 'vitrine' ? 'actif' : ''}`}
          onClick={() => setOnglet('vitrine')}
          aria-selected={onglet === 'vitrine'}
        >
          <span className="icone">🌐</span>
          <span>Vitrine</span>
        </button>
        <button
          className={`tabbar-bouton ${onglet === 'reglages' ? 'actif' : ''}`}
          onClick={() => setOnglet('reglages')}
          aria-selected={onglet === 'reglages'}
        >
          <span className="icone">⚙️</span>
          <span>Réglages</span>
        </button>
      </nav>
    </>
  );
}
